import React from "react"
import Layout from "../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>Invitations to Spaces</h1>
        </div>
        <ol>
          <li>
            <a href="#section1">Overview</a>
          </li>
          <li>
            <a href="#section2">Invitations</a>
          </li>
        </ol>
        <br />
        <div id="section1" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">1 Overview</h4>
          </div>
          <div className="panel-body">
            <p>
              To establish communication with another user (chat or video/audio)
              we can either:
            </p>
            <ul>
              <li>Search for them and open direct communication</li>
              <li>Add them to a space</li>
              <li>Create a space and invite them to it</li>
            </ul>
            <p />
            <p>
              It is important to note that that we can only search for users
              that are members of the same organization as us or that are in a
              space with us. To communicate with users outside our organization
              we must send them an invite link to join a space with us.
            </p>
          </div>
        </div>
        <div id="section2" className="panel panel-default">
          <div className="panel-heading">
            <h4 className="panel-title">2 Invitations</h4>
          </div>
          <div className="panel-body">
            <p>
              In Avaya Spaces, a member or admin can invite others to a space.
              Each space has a unique ID, passed to invitees through a URL link,
              such as
              https://spacesapis.avayacloud.com/spaces/invites/590b2342340466e51c2fd3c/join?inviteInfo=eyJzcGfsdxxxx.
            </p>
            <p>
              The invite URL for a space is (usually) passed to invitees via
              email. There are two options for this:
            </p>
            <ol>
              <li>
                Emailing from the Avaya Spaces server: let Avaya Cloud take care of the
                email invites.
              </li>
              <li>
                Emailing from another server: you can call the API to get
                invitation data and send the invitation email by yourself.
              </li>
            </ol>
            <p>
              Each invitee receives the same invitation link, which easily
              brings them to the space. The following scenarios may occur:
            </p>
            <ol>
              <li>
                <strong>The user is logged in to Avaya Cloud Accounts.</strong> The
                user's browser must present an authenticated session
                cookie/Avaya Spaces JWT. This is the simplest case, allowing
                users easy access to the space.
              </li>
              <li>
                <strong>The user is not logged in to Avaya Cloud Accounts.</strong>{" "}
                Avaya Spaces will direct the browser to a login page, allowing
                invitees to join as a user (requiring a login or signup) or as a
                guest (anonymous).
              </li>
            </ol>
            <p>
              Should the user choose to join anonymously, their browser will
              call the anonymous login API to recieve a JWT. All further REST
              API calls will have that token in the HTTP authorization header.
            </p>
            <p>
              To log into Avaya Cloud Accounts, the user can type their username and
              password or use SSO (google/office365/salesforce). Be careful-
              even after the user has logged in successfully, their email might
              not be on the invitation list, in which case they should be
              treated as an anonymous user.
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)
